





























import {
  Component, Prop, Vue,
} from 'vue-property-decorator'
import {Item} from 'src/layouts/default/MenuItem.type'
import ListItem from '@/components/list/ListItem.vue'
import MenuImg from '@/components/image/MenuImg.vue'

@Component({
  components: {
    MenuList: () => (import(/* webpackMode: "eager" */ './MenuList.vue')),
    ListItem,
    MenuImg,
  },
})
export default class MenuItem extends Vue {
  @Prop() menuName: string
  @Prop() title: string
  @Prop() leftIcon: string
  @Prop() notice: string
  @Prop() list: Item[]
  @Prop() rightIcon: string
  @Prop({default: false}) disabled: boolean
  @Prop() noticeColor: string
  @Prop() to: string
  @Prop() titleWeight: string
  @Prop() titleColor: string
  @Prop({default: 'subtitle'}) titleSize: string

  get sublistClasses(): string[] {
    return ['sub-list-item']
  }
}
